import { render, staticRenderFns } from "./EmploymentStatusChart.vue?vue&type=template&id=5d71fc84"
import script from "./EmploymentStatusChart.vue?vue&type=script&lang=js"
export * from "./EmploymentStatusChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports